/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Form_Isnotificationenabled_True2Inputs */



/**
* | output |
* | --- |
* | "Each state change will trigger a notification for users who have enabled GTB notifications" |
*
* @param {Alarms_Form_Isnotificationenabled_True2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const alarms_form_isnotificationenabled_true2 = /** @type {((inputs?: Alarms_Form_Isnotificationenabled_True2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Form_Isnotificationenabled_True2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Each state change will trigger a notification for users who have enabled GTB notifications")
	return /** @type {LocalizedString} */ ("Chaque changement d'état déclenchera une notification pour les utilisateurs ayant activé les notifications GTB")
});
export { alarms_form_isnotificationenabled_true2 as "alarms_form_isNotificationEnabled_true" }